import { useQuery } from '@tanstack/react-query';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';
import { QUERY_KEYS } from '../query-key';

interface Response {
  success: boolean;
  data: {
    nextAvailableId: string;
  };
  message: string;
}

export const useNextAvailableIdQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.sites.getNextAvailableId],
    queryFn: async (): Promise<string> => {
      const response = await XHRAuthorizedClient.get<Response>(
        ENDPOINTS.sites.nextAvailableId
      );
      return response.data.data.nextAvailableId.toString();
    },
  });
};
